import React, { useCallback, useMemo } from 'react';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints';

// GLOBAL FUNCTIONS
import { documentChunkFetch, getFileType, makePath, shouldOpenFile, viewFile } from 'functions.js';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';
import Button from 'core/tools/Button';

// STYLES
import styles from './attachmentLink.module.scss';

// COMPONENTS
const DownloadButton = ({ attachment }) => {

  // MEMOS
  const [
    attachmentID,
    fileName,
    isInventoryType,
    isSalesType,
    isTemp,
    uploadType = isInventoryType ? 'inventory' : isSalesType ? 'sales' : isTemp ? 'temp' : undefined,
    endpoint = ENDPOINTS.uploads[uploadType]?.view,
  ] = useMemo(
    () => [
      attachment.inventoryattachment_id || attachment.salesattachment_id || attachment.temp_attachment_id,
      attachment.inventoryattachment_filename || attachment.salesattachment_filename || attachment.fileName,
      !!attachment.inventoryattachment_id,
      !!attachment.salesattachment_id,
      !!attachment.temp_attachment_id
    ],
    [attachment]
  )

  // CALLBACKS
  const handleClick = useCallback(
    () => {
      const mimeType = getFileType(fileName) || 'text/plain';
      documentChunkFetch({
        endpoint: makePath(endpoint, attachmentID),
        mimeType,
        loadingMessage: shouldOpenFile(mimeType) ? 'Opening file' : 'Downloading file',
        errorMessage: 'Unable to download file.',
        onSuccess: r => viewFile({ ...r, fileName}, false, false, true),
      });
    },
    [attachmentID, fileName, endpoint]
  );

  // RENDER
  return (
    <Button.Link
      className={styles.button}
      label={fileName}
      icon="document"
      onClick={handleClick}
    />
  )

}

// MAIN COMPONENT
const AttachmentLink = ({ label, attachments, uploadType, ...props }) => (
  <Form.PlainText
    {...props}
    label={label}
    value={
      attachments?.map((attachment, i) => (
        <DownloadButton
          key={i}
          attachment={attachment}
        />
      ))
    }
  />
)

// EXPORT
export default AttachmentLink;